<common_article_breadcrumbs>

    <div class="breadcrumbs">
        <div class="sec-inner">
            <ul>
                <li each={(item,index) in state.breadcrumbs}>
                    <a if={item.link != ""} href={item.link}>{item.name}</a>
                    <span if={item.link==""}>{item.name}</span>
                </li>
            </ul>
        </div>
    </div>

    <script>

        export default {
            state:{
                breadcrumbs : [
                ]
            },onMounted(props,state){
                //this.state.breadcrumbs = page_breadcrumbs;
                this.update();

                let my = this;
                $(window).on("breadcrumbs:page_common_infos",function (event,data) {
                    my.state.breadcrumbs = data.breadcrumbs;
                    my.update();
                });
            }
        }

    </script>

</common_article_breadcrumbs>